export default async function createAccordions(containerSelector = '.js-acc-main', debug = false) {
  let containers = document.querySelectorAll(containerSelector);
  if (! containers.length) return;

  window.addEventListener('load', event => {
    init();
  });

  async function init() {
    const { default: AccordionsGroup } = await import('../classes/AccordionsGroup');
  
    containers.forEach(container => {
      new AccordionsGroup(container);
    });
  }
}
